import Vue from 'vue'
import Router from 'vue-router'
import Bagels from '@/components/Bagels'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/feedback',
      name: 'Feedback',
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLSd0JUf8bflT_OdNdR9K7ViMsUY5pJIMtaUuMKMFPaBDjE_U3g/viewform';
      }
    },
    {
      path: '/future',
      name: 'Future',
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://trello.com/b/Qvq8z8aC/bagels-today';
      }
    },
    {
      path: '/list',
      name: 'List',
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://docs.google.com/spreadsheets/d/1IufK0RGbgUhmy7ISVVoEj5HVEU8y5mxpLGBD9x5ALZk/edit?usp=sharing';
      }
    },
    {
      path: '/',
      name: 'Bagels',
      component: Bagels
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js